<template>
    <v-text-field :label="label" ref="autocomplete" v-model="addressComponent" :required="required"
        :prepend-icon="icon" :disabled="disabled" :rules="rules"></v-text-field>
</template>

<script>
import { Loader } from 'google-maps';

export default {
    name: 'GoogleMapsAutocomplete',
    props: {
        address: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        rules: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: "Dirección de residencia"
        },
        icon: {
            type: String,
            default: "mdi-map-marker"
        }
    },
    data() {
        return {
            autocomplete: null,
            addressComponent: "",
        };
    },
    mounted() {
        this.initAutocomplete();
    },
    watch: {
        addressComponent() {
            if (this.autocomplete) {
                this.fillInAddress();
            }
        },
        address(value){
            this.addressComponent = value;
        }
    },
    methods: {
        initAutocomplete() {
            const loader = new Loader(process.env.VUE_APP_GOOGLE_MAPS_API_KEY, {
                libraries: ['places', 'drawing', 'visualization'],
                region: 'MX',
            });
            loader.load().then(google=>{
                const input = this.$refs.autocomplete.$el.querySelector('input');
                this.autocomplete = new google.maps.places.Autocomplete(input, {
                    types: ['geocode'],
                    componentRestrictions: { country: 'mx' },
                    fields: ["formatted_address", "geometry", "name"],
                    strictBounds: false,
                });
                this.autocomplete.addListener("place_changed", this.fillInAddress)
                input.placeholder = "";
            }).catch(error => {
                console.error('Error loading Google Maps API', error);
            });
        },

        fillInAddress() {
            const place = this.autocomplete.getPlace();
            if(place){
                this.$emit('update-address', {
                    map_lat: place.geometry.location.lat(),
                    map_lng: place.geometry.location.lng(),
                    address: place.formatted_address,
                });
            }
        },
    },
};
</script>
